/* RESPONSIBLE TEAM: team-knowledge-foundations */

export enum ReviewStatus {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
  NotRelevant = 3,
}

export interface EntityScoreIssue {
  id: number;
  block_index: number | null;
  problematic_text: string;
  explanation: string;
  suggested_fix: string;
  rule_key?: string;
  review_status?: ReviewStatus;
}

export interface RuleResult {
  status: 'pass' | 'warn' | 'fail';
  points_awarded: number;
  issue_count: number;
  issues: EntityScoreIssue[];
}

export interface EntityScoreData {
  id: number;
  entity_type: number;
  entity_id: number;
  entity_title: string;
  total_score: number;
  priority: string;
  issue_count: number;
  scored_at: string;
  rule_results: Record<string, RuleResult>;
}
